import { create } from 'zustand';
import type { Stake, TableSize } from '@durakapp/shared';

interface LobbyState {
  stake: Stake;
  tableSize: TableSize;
  status: 'idle' | 'queueing' | 'queued' | 'matched' | 'error';
  error: string | null;
  matchId: string | null;
  setStake: (s: Stake) => void;
  setTableSize: (n: TableSize) => void;
  setStatus: (s: LobbyState['status']) => void;
  setError: (e: string | null) => void;
  setMatchId: (id: string | null) => void;
  reset: () => void;
}

export const useLobby = create<LobbyState>((set) => ({
  stake: 0,
  tableSize: 2,
  status: 'idle',
  error: null,
  matchId: null,
  setStake: (stake) => set({ stake }),
  setTableSize: (tableSize) => set({ tableSize }),
  setStatus: (status) => set({ status }),
  setError: (error) => set({ error }),
  setMatchId: (matchId) => set({ matchId }),
  reset: () => set({ status: 'idle', error: null, matchId: null }),
}));
